import React from 'react'
import { RowLayout } from '../RowLayout'
import { translation } from '../../i18n'
import {
  CaseBARespType,
  CaseCommonDataType,
  DamageTypeEnum,
  ItemRespType,
  LookupItemType,
  DestinationType,
  AttachmentType,
} from '../../models'
import { strToDateFormat } from '../../helpers'
import { OverviewRowAttachments } from './OverviewRowAttachments'
import { priceFormat } from '../../helpers/miscFunctions'

export type BaggageOverviewRespType = {
  caseCommon?: CaseCommonDataType
  caseBA?: CaseBARespType
  destinations: DestinationType[]
} & translation

export const BaggageOverview = (params: BaggageOverviewRespType) => {
  const t = params.t
  const itemTypes: LookupItemType[] = t(
    `itemTypes.${params.caseBA?.damageType}`
  ) as any // lookup

  return (
    <>
      <RowLayout
        text={t('baggageForm.occurredOn.label')}
        data={strToDateFormat(params.caseCommon?.occurredOn)}
      />
      <RowLayout
        text={t('baggageForm.destination.label')}
        data={
          params.destinations.find(
            (item: DestinationType) =>
              item.code === params?.caseCommon?.destination
          )?.name ?? params?.caseCommon?.destination
        }
      />
      <RowLayout
        text={t('baggageForm.resort.label')}
        data={params.caseCommon?.resort}
      />
      <RowLayout
        text={t('baggageForm.place.label')}
        data={params.caseCommon?.place}
      />
      <RowLayout
        text={t('baggageForm.damageType.label')}
        data={t(`damageTypes.${params.caseBA?.damageType}`)}
      />
      {params.caseCommon?.description !== '' && (
        <React.Fragment>
          <RowLayout
            text={t('baggageForm.description.label')}
            data={params.caseCommon?.description}
          />
        </React.Fragment>
      )}
      {params.caseBA?.damageType === DamageTypeEnum.DELAY && (
        <React.Fragment>
          <RowLayout
            text={t('baggageForm.baggageDateTime.label')}
            data={params.caseBA?.baggageDateTime}
          />
        </React.Fragment>
      )}
      {params.caseBA?.damageType === DamageTypeEnum.THEFT && (
        <React.Fragment>
          <RowLayout
            text={t('baggageForm.theftReported.label')}
            //@ts-ignore
            data={!!params.caseBA?.theftReported ? t('yes') : t('no')}
          />
        </React.Fragment>
      )}
      <OverviewRowAttachments
        text={t('attachments.CASEBA.REPORT')}
        attachmentList={params.caseBA?.attachmentList}
        attachmentType={AttachmentType.REPORT}
      />
      <OverviewRowAttachments
        text={t('attachments.CASEBA.PASS')}
        attachmentList={params.caseBA?.attachmentList}
        attachmentType={AttachmentType.PASS}
      />
      <OverviewRowAttachments
        text={t('attachments.CASEBA.TICKET')}
        attachmentList={params.caseBA?.attachmentList}
        attachmentType={AttachmentType.TICKET}
      />
      <OverviewRowAttachments
        text={t('attachments.CASEBA.PIR')}
        attachmentList={params.caseBA?.attachmentList}
        attachmentType={AttachmentType.PIR}
      />
      {params.caseBA?.items?.map((item: ItemRespType, index: number) => {
        return (
          <React.Fragment key={index}>
            <RowLayout
              text={t(
                `baggageForm.items.itemType.label.${params.caseBA?.damageType}`
              )}
              data={
                itemTypes.find(
                  (lookupItem) => lookupItem.code === item.itemType
                )?.name ?? item.itemType
              }
            />
            <RowLayout
              text={t(
                `baggageForm.items.description.label.${params.caseBA?.damageType}`
              )}
              data={item.description}
            />
            <RowLayout
              text={t(
                `baggageForm.items.purchaseDate.label.${params.caseBA?.damageType}`
              )}
              data={strToDateFormat(item.purchaseDate)}
            />
            <RowLayout
              text={t('baggageForm.items.amount.label')}
              data={priceFormat({
                price: item.amount,
                currency: item.currency,
              })}
            />
            {params.caseBA?.damageType === 'LOSS' && (
              <OverviewRowAttachments
                text={t('attachments.CASEBA.PIR')}
                attachmentList={params.caseBA?.attachmentList}
                attachmentType={AttachmentType.PIR}
              />
            )}
            {params.caseBA?.damageType === 'THEFT' && (
              <React.Fragment>
                <OverviewRowAttachments
                  text={t('attachments.CASEBA.PIR')}
                  attachmentList={params.caseBA?.attachmentList}
                  attachmentType={AttachmentType.PIR}
                />
              </React.Fragment>
            )}
            {params.caseBA?.damageType === 'LOSS' && (
              <OverviewRowAttachments
                text={t('attachments.ITEMBA.PHOTO')}
                attachmentList={item?.attachmentList}
                attachmentType={AttachmentType.PHOTO}
              />
            )}
            <OverviewRowAttachments
              text={t('attachments.ITEMBA.INVOICE')}
              attachmentList={item?.attachmentList}
              attachmentType={AttachmentType.INVOICE}
            />
          </React.Fragment>
        )
      })}
    </>
  )
}
